import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, User, ChevronRight, Settings, Wrench } from "lucide-react";
import { Header } from "../../components/layout/Header";
import { Card } from "../../components/common/Card";
import { Avatar } from "../../components/common/Avatar";
import { useAuth } from "../../contexts/AuthContext";

export default function MorePage() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <>
      <Header title='More' showNotifications={false} />
      <div className='px-4 py-4 space-y-4'>
        {/* Profile card */}
        <Card accent='#102232' onClick={() => navigate("/profile/setup")}>
          <div className='flex items-center gap-3'>
            <Avatar src={user?.photoURL} name={user?.displayName} size='lg' />
            <div className='flex-1'>
              <p className='font-bold text-primary-800'>
                {user?.displayName ?? "Golfer"}
              </p>
              <p className='text-xs text-gray-400'>{user?.email}</p>
              {user?.handicap != null && (
                <p className='text-xs text-secondary-400 font-medium mt-0.5'>
                  Handicap {user.handicap}
                </p>
              )}
            </div>
            <ChevronRight size={18} className='text-gray-300' />
          </div>
        </Card>

        {/* Settings */}
        <Card onClick={() => {}}>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center'>
              <Settings size={18} className='text-gray-500' />
            </div>
            <span className='font-medium text-primary-800 flex-1'>
              Settings
            </span>
            <ChevronRight size={16} className='text-gray-300' />
          </div>
        </Card>

        {/* Sign out */}
        <Card onClick={handleSignOut}>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-xl bg-red-50 flex items-center justify-center'>
              <LogOut size={18} className='text-red-500' />
            </div>
            <span className='font-medium text-red-500 flex-1'>Sign Out</span>
          </div>
        </Card>

        {/* Dev Tools – remove before production */}
        <Card onClick={() => navigate("/dev")} accent='#d97706'>
          <div className='flex items-center gap-3'>
            <div className='w-9 h-9 rounded-xl bg-amber-50 flex items-center justify-center'>
              <Wrench size={18} className='text-amber-500' />
            </div>
            <span className='font-medium text-amber-600 flex-1'>Dev Tools</span>
            <span className='text-[10px] bg-amber-100 text-amber-600 px-2 py-0.5 rounded-full font-semibold'>
              DEV
            </span>
            <ChevronRight size={16} className='text-gray-300' />
          </div>
        </Card>
      </div>
    </>
  );
}
